<template>
  <div>
    <home-hero-banner></home-hero-banner>
    <location-box></location-box>
    <opening-times-box></opening-times-box>
    <contact-box></contact-box>
  </div>
</template>
<script>
import HomeHeroBanner from "./home/home-hero-banner";
import LocationBox from "./home/location-box";
import OpeningTimesBox from "./home/opening-times-box";
import ContactBox from "./home/contact-box";
import { getAllDepartments } from "../../api/departments/departments";

export default {
  name: 'grotec-home',
  components: { ContactBox, OpeningTimesBox, LocationBox, HomeHeroBanner },
  data() {
    return {}
  }
}
</script>